import * as getters from "../../baseQuestion/text/store/getters";
import * as mutations from "../../baseQuestion/text/store/mutations";
import * as actions from "../../baseQuestion/text/store/actions";
import { state as checkbox_state } from "../../baseQuestion/checkbox/store/state";

function state() {
	return checkbox_state();
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
